export default "__VITE_ASSET__948b50df__"